/*
 * MGM Gift — cadeaux popup ajoutés automatiquement au panier.
 *
 * Un "entitlement" est accordé par le popup scratch après capture email
 * (MGMGift.grant). Il est persisté en localStorage puis synchronisé avec le
 * panier : la variante cadeau est ajoutée dès que le produit principal est
 * présent, retirée s'il disparaît. Le passage à 0 € se fait via le code promo
 * Buy X Get Y, appliqué par l'API Cart AJAX une fois le cadeau au panier
 * (fallback cookie /discount/ si l'AJAX échoue).
 */
(function () {
  var STORAGE_KEY = 'mgm_gift_entitlements';
  var DECLINED_KEY = 'mgm_gift_declined';
  var CAMPAGNE_PREFIX = 'cmp-';
  var GIFT_PROP = '_mgm_gift';
  var syncing = null;
  var appliedCodes = {};

  function readEntitlements() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var data = raw ? JSON.parse(raw) : {};
      return data && typeof data === 'object' ? data : {};
    } catch (e) {
      return {};
    }
  }

  function writeEntitlements(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function readDeclined() {
    try {
      return JSON.parse(localStorage.getItem(DECLINED_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function campagneEntitlements() {
    var campagne = window.MGMCampagne;
    var out = {};
    if (!campagne || !campagne.cadeaux) return out;
    var declined = readDeclined();
    campagne.cadeaux.forEach(function (g) {
      out[g.ns] = {
        ns: g.ns,
        variantId: String(g.variantId),
        trigger: g.trigger,
        accept: g.accept.map(String),
        label: g.label,
        declined: !!declined[g.ns]
      };
    });
    return out;
  }

  function allEntitlements() {
    var all = readEntitlements();
    var campagne = campagneEntitlements();
    Object.keys(campagne).forEach(function (ns) { all[ns] = campagne[ns]; });
    return all;
  }

  /*
   * Applique le code en s'appuyant sur l'API Cart AJAX (champ discount de
   * /cart/update.js) : fonctionne aussi derrière le proxy de theme dev, là où
   * la route cookie /discount/ répond 401. Cette dernière reste en fallback.
   */
  function applyDiscountCode(code) {
    if (!code) return Promise.resolve();
    return MGMFunnel.addDiscountCodes([code]).catch(function () {
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .catch(function () {});
    });
  }

  var I18N = window.MGM_I18N || { gift_property_name: 'Gift', gift_default_label: 'Free with your order' };

  function cartAdd(entitlement) {
    var properties = {};
    properties[GIFT_PROP] = entitlement.ns;
    properties[I18N.gift_property_name] = entitlement.label || I18N.gift_default_label;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(entitlement.variantId), quantity: 1, properties: properties }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add ' + r.status);
      return r.json();
    });
  }

  function findGiftLine(cart, entitlement) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (String(it.variant_id) === String(entitlement.variantId) && it.properties && it.properties[GIFT_PROP]) {
        return it;
      }
    }
    return null;
  }

  function mainProductInCart(cart, entitlement) {
    var items = (cart && cart.items) || [];
    var trigger = entitlement.trigger || [entitlement.mainProductId];
    for (var i = 0; i < items.length; i++) {
      if (isGiftItem(items[i])) continue;
      if (trigger === 'any' || trigger.map(String).indexOf(String(items[i].product_id)) !== -1) return true;
    }
    return false;
  }

  function paidLine(cart, entitlement) {
    if (!entitlement.accept) return null;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (!isGiftItem(items[i]) && entitlement.accept.indexOf(String(items[i].variant_id)) !== -1) return items[i];
    }
    return null;
  }

  function computeOps(cart, entitlements) {
    var ops = [];
    var seen = {};
    ((cart && cart.items) || []).forEach(function (it) {
      var ns = giftNamespace(it);
      if (ns && seen[ns]) ops.push({ type: 'remove', key: it.key });
      if (ns) seen[ns] = true;
    });
    Object.keys(entitlements).forEach(function (ns) {
      var e = entitlements[ns];
      if (!e || !e.variantId || !(e.mainProductId || e.trigger)) return;
      var giftLine = findGiftLine(cart, e);
      var mainIn = mainProductInCart(cart, e);
      var paid = paidLine(cart, e);
      if (mainIn && !giftLine && !paid && !e.declined) {
        ops.push({ type: 'add', entitlement: e });
      } else if (giftLine && (!mainIn || paid)) {
        ops.push({ type: 'remove', key: giftLine.key });
      } else if (giftLine && giftLine.quantity > 1) {
        ops.push({ type: 'clamp', key: giftLine.key });
      }
    });
    ((cart && cart.items) || []).forEach(function (it) {
      var ns = giftNamespace(it);
      if (ns.indexOf(CAMPAGNE_PREFIX) === 0 && !entitlements[ns]) ops.push({ type: 'remove', key: it.key });
    });
    return ops;
  }

  // Retraits groupés dans un seul /cart/update.js : un retrait peut changer la clé des autres lignes.
  function runOps(ops) {
    var updates = {};
    ops.forEach(function (op) {
      if (op.type !== 'add') updates[op.key] = op.type === 'remove' ? 0 : 1;
    });
    var chain = Object.keys(updates).length
      ? fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        }).catch(function (e) {
          if (window.console && console.warn) console.warn('[MGMGift] update failed', e);
        })
      : Promise.resolve();
    ops.forEach(function (op) {
      if (op.type !== 'add') return;
      chain = chain.then(function () {
        return cartAdd(op.entitlement);
      }).catch(function (e) {
        if (window.console && console.warn) console.warn('[MGMGift] op failed', op.type, e);
      });
    });
    return chain;
  }

  /*
   * Le code n'est appliqué qu'une fois la ligne cadeau réellement au panier
   * (sinon la condition Buy X Get Y n'est pas remplie), et une seule fois par
   * chargement de page.
   */
  function ensureDiscounts(cart, entitlements) {
    var chain = Promise.resolve();
    Object.keys(entitlements).forEach(function (ns) {
      var e = entitlements[ns];
      if (!e || !e.code || e.declined || appliedCodes[e.code]) return;
      if (!findGiftLine(cart, e)) return;
      appliedCodes[e.code] = true;
      chain = chain.then(function () { return applyDiscountCode(e.code); });
    });
    return chain;
  }

  /*
   * Réconcilie panier et entitlements. Résout { changed, cart } ; `cart` est
   * le panier à jour (refetch après mutation). Les appels concurrents
   * partagent la même promesse pour éviter les doubles ajouts.
   */
  function sync(cart) {
    if (syncing) return syncing;
    var entitlements = allEntitlements();
    if (!Object.keys(entitlements).length && !window.MGMCampagne && !cart) {
      return Promise.resolve({ changed: false, cart: cart || null });
    }
    // Toujours relire le panier : un panier passé par l'appelant peut dater d'avant le dernier sync et faire ajouter les cadeaux en double.
    syncing = MGMFunnel.cart().then(function (c) {
      var ops = computeOps(c, entitlements);
      var mutated = ops.length > 0;
      var afterOps = mutated
        ? runOps(ops).then(function () { return MGMFunnel.cart(); })
        : Promise.resolve(c);
      return afterOps.then(function (fresh) {
        return ensureDiscounts(fresh, entitlements).then(function () {
          if (mutated) {
            try {
              document.dispatchEvent(new CustomEvent('mgm:gift:synced', { detail: { cart: fresh } }));
            } catch (e) {}
          }
          return { changed: mutated, cart: fresh };
        });
      });
    }).catch(function () {
      return { changed: false, cart: cart || null };
    }).then(function (result) {
      syncing = null;
      return result;
    });
    return syncing;
  }

  function grant(opts) {
    if (!opts || !opts.ns || !opts.variantId || !opts.mainProductId) return Promise.resolve({ changed: false, cart: null });
    var entitlements = readEntitlements();
    entitlements[opts.ns] = {
      ns: String(opts.ns),
      code: String(opts.code || ''),
      variantId: String(opts.variantId),
      mainProductId: String(opts.mainProductId),
      label: String(opts.label || ''),
      declined: false,
      grantedAt: Date.now()
    };
    writeEntitlements(entitlements);
    return sync();
  }

  /* Le client a retiré son cadeau du panier : ne pas le re-ajouter. */
  function decline(ns) {
    if (String(ns).indexOf(CAMPAGNE_PREFIX) === 0) {
      var declined = readDeclined();
      declined[ns] = true;
      try { localStorage.setItem(DECLINED_KEY, JSON.stringify(declined)); } catch (e) {}
      return;
    }
    var entitlements = readEntitlements();
    if (entitlements[ns]) {
      entitlements[ns].declined = true;
      writeEntitlements(entitlements);
    }
  }

  function isGiftItem(item) {
    return !!(item && item.properties && item.properties[GIFT_PROP]);
  }

  function giftNamespace(item) {
    return isGiftItem(item) ? String(item.properties[GIFT_PROP]) : '';
  }

  /* Total (en centimes) des lignes cadeaux, à déduire de l'affichage. */
  function giftDiscountCents(cart) {
    var sum = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (isGiftItem(it)) {
        sum += it.final_line_price != null ? it.final_line_price : (it.line_price || 0);
      }
    });
    return sum;
  }

  window.MGMGift = {
    grant: grant,
    sync: sync,
    decline: decline,
    isGiftItem: isGiftItem,
    giftNamespace: giftNamespace,
    giftDiscountCents: giftDiscountCents
  };

  /* Le produit principal vient d'être ajouté : le cadeau suit immédiatement. */
  document.addEventListener('product:added-to-cart', function () { sync(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); });
  } else {
    sync();
  }
})();
